<template>
	<div id="AssistantActionEdit" class="assistant-action-edit">
		<div class="container">
			<div>
				<div class="form-group row">
					<label for="inputID" class="col-sm-2 col-form-label">ID</label>
					<div class="col-sm-10">
						<input type="text" class="form-control form-control-sm" id="inputID" v-model="objectAssistantAction.id">
					</div>
				</div>
				<div class="form-group row">
					<label for="inputOption" class="col-sm-2 col-form-label">Opción</label>
					<div class="col-sm-10">
						<input type="text" class="form-control form-control-sm" id="inputOption" v-model="objectAssistantAction.option">
					</div>
				</div>
				<div class="form-group row">
					<label for="inputMessageBegin" class="col-sm-2 col-form-label">Mensaje Inicial</label>
					<div class="col-sm-10">
						<textarea class="form-control form-control-sm" id="inputMessageBegin" v-model="objectAssistantAction.message_begin"></textarea>
					</div>
				</div>
				<div class="form-group row">
					<label for="inputMessageEnd" class="col-sm-2 col-form-label">Mensaje Inicial</label>
					<div class="col-sm-10">
						<textarea class="form-control form-control-sm" id="inputMessageEnd" v-model="objectAssistantAction.message_end"></textarea>
					</div>
				</div>
				<div class="text-right">
					<button class="btn btn-primary btn-sm" @click="saveAssistantActionLocal" :disabled="disabledBtnSaveAssistantAction">Guardar</button>
				</div>
			</div>
			<hr>
		</div>

			<pre>
				{{ objectAssistantAction }}
			</pre>
		</div>
	</div>
</template>

<script>
import mixin from '@/mixins'
import errors from '@/mixins/errors.js'
import axiosAction from '@/mixins/axiosAction.js'
import assistantAction from '@/mixins/generals/assistantAction.js'

import ListAssistantActionComponent from '@/components/ListAssistantActionComponent.vue'

export default {
	name: 'AssistantActionEdit',
	mixins: [axiosAction, errors, mixin, assistantAction],
	props: ['id', 'actionId'],
	data() {
		return {
		}
	},
	components: {
		//'list-assistant-action-option-component': ListAssistantActionOptionComponent,
	},
	computed: {
		disabledBtnSaveAssistantAction() {
			return this.savingAssistantAction
		}
	},
	methods: {
		initModuleLocal() {
			this.setTitleModule('Buscando el Asistente con el ID ' + this.id)
			this.setSubTitleModule('')
			this.showAssistantActionLocal()
		},
		resultAxiosLocal(responseLocal, response) {
			switch(responseLocal) {
				case 'saveAssistantActionResult': this.saveAssistantActionResult(response); break;
				case 'showAssistantActionResult': this.showAssistantActionResult(response); break;
				default: console.log('Acción no determinada despues de la consulta (' + responseLocal + ')'); break;
			}
        },
		saveAssistantActionLocal() {
			this.saveAssistantAction()
		},
		saveAssistantActionResultLocal(response) {

		},
		showAssistantActionLocal() {
			if(this.actionId > 0) {
				this.showAssistantAction(this.actionId)
			}
		},
		showAssistantActionResultLocal(response) {
			console.log(response, this.objectAssistantAction)
			if(this.objectAssistantAction.id > 0) {
				//this.setTitleModule('Assisten ' + this.objectAssistant.name + ' #' + this.objectAssistant.id)
				//setTimeout(() => { this.$refs.listAssistantAction.$refs.btnGetAssistantActionByAssistantId.click() }, 100)
			}
		},
	},
	mounted () {
		this.initModule()
	}
}

</script>

<style scoped lang="scss">
</style>